import { Pipe, PipeTransform } from '@angular/core';
import { TransactionType } from '@portal/entity-services/interfaces/src';

@Pipe({
    name: 'localizeTransactionType',
    standalone: false
})
export class LocalizeTransactionTypePipe implements PipeTransform {
  transform(value: TransactionType): string {
    const localizationMap = {
      [TransactionType.Authorisation]: $localize`:@@transactionType.authorisation:Authorisation`,
      [TransactionType.Balance]: $localize`:@@transactionType.balance:Balance`,
      [TransactionType.Cancel]: $localize`:@@transactionType.cancel:Cancel`,
      [TransactionType.Capture]: $localize`:@@transactionType.capture:Capture`,
      [TransactionType.CardActivation]: $localize`:@@transactionType.cardActivation:Card Activation`,
      [TransactionType.CardDeactivation]: $localize`:@@transactionType.cardDeactivation:Card Deactivation`,
      [TransactionType.CardVerification]: $localize`:@@transactionType.cardVerification:Card Verification`,
      [TransactionType.CashAdvance]: $localize`:@@transactionType.cashAdvance:Cash Advance`,
      [TransactionType.CashDeposit]: $localize`:@@transactionType.cashDeposit:Cash Deposit`,
      [TransactionType.ClearBatch]: $localize`:@@transactionType.clearBatch:Clear Batch`,
      [TransactionType.Declined]: $localize`:@@transactionType.declined:Declined`,
      [TransactionType.DelayedCharge]: $localize`:@@transactionType.delayedCharge:Delayed Charge`,
      [TransactionType.ForexRate]: $localize`:@@transactionType.forexRate:Forex Rate`,
      [TransactionType.Load]: $localize`:@@transactionType.load:Load`,
      [TransactionType.NoShow]: $localize`:@@transactionType.noShow:No Show`,
      [TransactionType.NonFinancial]: $localize`:@@transactionType.nonFinancial:Non Financial`,
      [TransactionType.PreAuth]: $localize`:@@transactionType.preAuth:Preauth`,
      [TransactionType.PreAuthIncrement]: $localize`:@@transactionType.preAuthIncrement:Preauth Increment`,
      [TransactionType.PreAuthCompletion]: $localize`:@@transactionType.preAuthCompletion:Preauth Completion`,
      [TransactionType.PreInquiry]: $localize`:@@transactionType.preInquiry:Preauth Inquiry`,
      [TransactionType.PreUpload]: $localize`:@@transactionType.preUpload:Preauth Upload`,
      [TransactionType.PreReversal]: $localize`:@@transactionType.preReversal:Preauth Reversal`,
      [TransactionType.Settlement]: $localize`:@@transactionType.settlement:Settlement`,
      [TransactionType.Rate]: $localize`:@@transactionType.rate:Rate`,
      [TransactionType.Refund]: $localize`:@@transactionType.refund:Refund`,
      [TransactionType.RefundVoid]: $localize`:@@transactionType.refundVoid:Refund Void`,
      [TransactionType.Reversal]: $localize`:@@transactionType.reversal:Reversal`,
      [TransactionType.Sale]: $localize`:@@transactionType.sale:Sale`,
      [TransactionType.Unload]: $localize`:@@transactionType.unload:Unload`,
      [TransactionType.Void]: $localize`:@@transactionType.void:Void`,
      [TransactionType.Reauthorisation]: $localize`:@@transactionType.reauthorisation:Reauthorization`,
      [TransactionType.Extend]: $localize`:@@transactionType.extend:Extend`,
      [TransactionType.FundsTransfer]: $localize`:@@transactionType.fundsTransfer:Funds Transfer`,
      [TransactionType.Hold]: $localize`:@@transactionType.hold:Hold`,
      [TransactionType.Payout]: $localize`:@@transactionType.payout:Payout`,
      [TransactionType.Release]: $localize`:@@transactionType.release:Release`,
      [TransactionType.Chargeback]: $localize`:@@transactionType.chargeback:Chargeback`,
      [TransactionType.DisputeDebit]: $localize`:@@transactionType.disputeDebit:Dispute Debit`,
      [TransactionType.DisputeCredit]: $localize`:@@transactionType.disputeCredit:Dispute Credit`,
      [TransactionType.RedemptionOrder]: $localize`:@@transactionType.redemptionOrder:Redemption Order`,
    };

    return localizationMap[value] || value;
  }
}
